import { render, staticRenderFns } from "./product.vue?vue&type=template&id=4bdcdc9b&"
import script from "./product.vue?vue&type=script&setup=true&lang=js&"
export * from "./product.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=4bdcdc9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports